// Hook listy wersji oferty (dla selecta wersji w nagłówku).
// GET /sales-crm/clients/:cid/offers/:oid/versions

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmOfferVersionListItem {
  id: number;
  ordinal: number;
  status: number | null;
  isActual: boolean;
  createdAt: string | null;
}

export interface ISalesCrmOfferVersionsResponse {
  items: ISalesCrmOfferVersionListItem[];
}

export const getSalesCrmOfferVersionsQueryKey = (clientId: number, offerId: string) =>
  ['sales-crm', 'client', clientId, 'offer', offerId, 'versions'] as const;

const getSalesCrmOfferVersions = (
  clientId: number,
  offerId: string
): Promise<ISalesCrmOfferVersionsResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/offers/${offerId}/versions`);

export const useGetSalesCrmOfferVersions = (
  clientId: number,
  offerId: string,
  options?: UseQueryOptions<ISalesCrmOfferVersionsResponse, IError>
) =>
  useQuery<ISalesCrmOfferVersionsResponse, IError>(
    getSalesCrmOfferVersionsQueryKey(clientId, offerId),
    () => getSalesCrmOfferVersions(clientId, offerId),
    {
      ...options,
      enabled: options?.enabled !== false && clientId > 0 && String(offerId).trim().length > 0
    }
  );
